import Phaser from 'phaser'
var replayButton 
export default class YouWinscene extends
Phaser.Scene 
{ 
    constructor () 
    {  
        super('you-win-scene')
    }

    init (data) 
    {
        this.score = data.score 
    }
    
    preload() 
    {
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('youwin', 'images/youwin.png')
        this.load.image('replay', 'images/replay.png')
        this.load.image('reo', 'images/reo.png')
    }

    create() 
    { 
        this.add.image (200,320, 'background')
        this.add.image (200, 300, 'youwin')
        this.add.image (200, 80, 'reo')
        this.replayButton= this.add.image (200, 500, 'replay').setInteractive()
        this.replayButton.once('pointerup', () => { this.scene.start('corona-buster-scene') }, this)
        
     
    }

}
